export const LABEL_COLOR = "rgb(51, 51, 51)";
